import React, { useEffect, useState } from 'react';
import CustomEditCard from '../../../../common/components/CustomEditCard/CustomEditCard';
import _ from 'lodash';
import GovtTaxTileContent from '../../../../common/components/GovtTaxTileContent/GovtTaxTileContent';
import GovtTaxEditModalController from '../../../../common/Modals/Salary/GovtTaxEditModal/GovtTaxEditModalController';
import {
  check_user_permission,
  getAmount,
} from '../../../../common/configs/utils';
import { useAppSelector } from '../../../../infra/hooks';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import { usePermission } from '../../../../hooks';

interface propsType {
  employeeGovtTaxData: any;
  currency: any;
  isLoading?: boolean;
  trans?: any;
}
const GovtTaxPresenter: React.FC<propsType> = ({
  employeeGovtTaxData,
  currency,
  isLoading,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);

  const userCanShowSalary = usePermission('Employee Portal Show Salary');

  return (
    <div>
      <CustomEditCard
        card_title={trans('Government Tax')}
        card_height="380px"
        onClick={() => setOpenModal(true)}
        showEditButton={false}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : userCanShowSalary ? (
          <div>
            {_.map(employeeGovtTaxData, (govtTax: any) => {
              return (
                <GovtTaxTileContent
                  taxName={govtTax?.name}
                  currency={currency}
                  salaryFrom={
                    govtTax?.salary_from ? getAmount(govtTax?.salary_from) : 0
                  }
                  salaryTo={getAmount(govtTax?.salary_to)}
                  taxFor={govtTax?.applicable_on}
                  taxType={govtTax?.tax_type}
                  taxValue={govtTax?.value}
                  taxApplicables={govtTax?.tax_allowances}
                />
              );
            })}
          </div>
        ) : (
          <div
            style={{
              color: 'red',
              padding: '30px',
              borderLeft: '4px solid red',
              fontWeight: 'bold',
              opacity: '0.6',
            }}
          >
            {trans("You Don't have Permission please contact with admin")}
          </div>
        )}
      </CustomEditCard>

      {/* Employee Govt Tax Edit Modal */}

      {openModal && (
        <GovtTaxEditModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          trans={trans}
        />
      )}
    </div>
  );
};

export default GovtTaxPresenter;
